import AdmissionsHeader from "./AdmissionsHeader";
import AssignmentsHeader from "./AssignmentsHeader";
import ClassesHeader from "./ClassesHeader";
import CoursesHeader from "./CoursesHeader";
import ReportCardsHeader from "./ReportCardsHeader";
import SchedulingHeader from "./SchedulingHeader";
import SchoolProfileHeader from "./SchoolProfileHeader";
import SocialDevelopmentHeader from "./SocialDevelopmentHeader";
import StaffHeader from "./StaffHeader";
import StaffInfoHeader from "./StaffInfoHeader";
import StudentInfoHeader from "./StudentInfoHeader";
import StudentsHeader from "./StudentsHeader";
import SubjectHeader from "./SubjectHeader";

// String key -> header definition, the single source of truth for which legacy
// pages can mount a v2 page header. The v1 bridge component (V2PageHeader) passes
// one of these keys. Definitions render under an inert MemoryRouter, so they must
// navigate through the onNavigate callback their params carry, never useNavigate.
const PAGE_HEADERS = {
  admissions: AdmissionsHeader,
  assignments: AssignmentsHeader,
  classes: ClassesHeader,
  courses: CoursesHeader,
  "report-cards": ReportCardsHeader,
  scheduling: SchedulingHeader,
  "school-profile": SchoolProfileHeader,
  "social-development": SocialDevelopmentHeader,
  staff: StaffHeader,
  "staff-info": StaffInfoHeader,
  "student-info": StudentInfoHeader,
  students: StudentsHeader,
  subject: SubjectHeader,
};

export default PAGE_HEADERS;
